const MONTHS = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Septiembre',
  'Octubre',
  'Noviembre',
  'Diciembre',
]
export default function formatStringDate(date: string) {
  // format=year-month-date
  let spdate = date.split('-')
  let year = spdate[0]
  let month = MONTHS[parseInt(spdate[1]) - 1]
  let day = spdate[2]
  return ` ${day} de ${month} del ${year}`
}
